<template>
    <div class="mx-auto flex max-w-4xl flex-col items-center justify-between lg:flex-row">
        <div>
            <CHeading tag="h2">{{ title }}</CHeading>

            <slot />
        </div>

        <img alt="404 image" loading="lazy" src="@/assets/images/404-picture.png" />
    </div>
</template>

<script setup lang="ts">
import CHeading from '@/components/ui/CHeading.vue'

defineProps({
    title: {
        type: String,
        default: 'Oops!'
    }
})
</script>
